import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import { IconDownload } from '@tabler/icons-react';
import axios from '../../../../library/axios';
import { downloadTenantImportTemplate } from '../../../../helpers/cpanelImportTemplates';
import {
  handleJobQueuedSuccess,
  handleJobRequestError,
} from '../../../../helpers/cpanelJobFeedback';
import {
  hasValidationErrors,
  IMPORT_ALLOWED_EXTENSIONS,
  IMPORT_MAX_FILE_BYTES,
  validateImportFile,
} from './validation';

const ImportCpanelTenantComp = ({ close, fetch }) => {
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [file, setFile] = useState(null);
  const [errors, setErrors] = useState({});

  const handleFileChange = (selectedFile) => {
    setFile(selectedFile);
    setErrors(validateImportFile(selectedFile));
  };

  const handleImport = async (event) => {
    event?.preventDefault();

    const nextErrors = validateImportFile(file);
    setErrors(nextErrors);

    if (hasValidationErrors(nextErrors)) {
      return;
    }

    setLoading(true);
    setDisabled(true);

    const formData = new FormData();
    formData.append('filePath', file);

    try {
      const response = await axios({
        url: '/cpanel/tenants/import',
        method: 'POST',
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      const queued = await handleJobQueuedSuccess({
        response,
        actionLabel: 'Import tenant',
        close,
        fetch,
      });

      if (!queued) {
        close();
        fetch();
      }
    } catch (err) {
      handleJobRequestError(err, 'Tidak dapat memulai import tenant.');
    } finally {
      setLoading(false);
      setDisabled(false);
    }
  };

  const acceptTypes = IMPORT_ALLOWED_EXTENSIONS.join(',');

  return (
    <form noValidate onSubmit={handleImport}>
      <div className="d-flex flex-wrap align-items-start justify-content-between gap-2 mb-3">
        <p className="text-muted small mb-0">
          Unduh template XLSX, isi kolom <strong>slug</strong>, <strong>description</strong>, dan{' '}
          <strong>kode_verifikasi</strong>, lalu unggah file (CSV, XLS, atau XLSX).
        </p>
        <Button
          type="button"
          variant="outline-primary"
          size="sm"
          className="flex-shrink-0"
          onClick={downloadTenantImportTemplate}
        >
          <IconDownload size={16} stroke={1.75} className="me-1" />
          Template XLSX
        </Button>
      </div>
      <div className="mb-4">
        <label htmlFor="tenantImportFile" className="form-label required">
          File impor
        </label>
        <input
          type="file"
          className={`form-control${errors.file ? ' is-invalid' : ''}`}
          id="tenantImportFile"
          accept={acceptTypes}
          required
          onChange={(e) => handleFileChange(e.target.files?.[0] || null)}
          onBlur={() => {
            const nextErrors = validateImportFile(file);
            if (nextErrors.file) {
              setErrors(nextErrors);
            }
          }}
        />
        {errors.file ? <div className="invalid-feedback d-block">{errors.file}</div> : null}
        <div className="form-text">
          Format: CSV, XLS, XLSX (maks.{' '}
          {Math.round(IMPORT_MAX_FILE_BYTES / (1024 * 1024))} MB).
        </div>
      </div>

      <div className="alert alert-light border mb-4 py-2 px-3 fs-7 text-muted mb-0">
        File di-queue ke Job Runner. Jika satu baris gagal, job dihentikan, atau server crash, semua tenant
        yang sudah terbentuk di job ini akan di-rollback (database, folder, dan record dihapus).
      </div>

      <div className="d-flex justify-content-start gap-2">
        <Button variant="light" size="sm" onClick={close}>
          Tutup
        </Button>
        <Button type="submit" variant="primary" size="sm" disabled={disabled}>
          {loading ? 'Memulai job...' : 'Impor'}
        </Button>
      </div>
    </form>
  );
};

export default ImportCpanelTenantComp;
